import React from "react";
import TeamTabContent from "./components/TeamTabContent/TeamTabContent";

const MetaList = () => {
  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <div className="mb-4 shrink-0">
        <h1 className="text-2xl font-bold tracking-tight text-[#1E1B4B] sm:text-3xl">
          Department List
        </h1>
        <p className="mt-1 text-sm text-[#6B7280]">
          Manage your department list here
        </p>
      </div>
      <div className="min-h-0 flex-1">
        <TeamTabContent />
      </div>
    </div>
  );
};

export default MetaList;
